import {TransformerInterface} from "../transformers/transformerInterface";
import {TransformerDecoratorOptions} from "./transformer-decorator-options.interface";
import {container} from "tsyringe";
import {TransformerHelper} from "../helpers/transformer.helper";
import {DtoDirection} from "../transformers/dto-direction.enum";

export function transformer<T>(options: TransformerDecoratorOptions<T>) {

    return function (constructor: { new (...args: any[]): TransformerInterface<any, any> }) {
        if (!options?.target) {
            return;
        }

        if (!options?.source) {
            return;
        }

        const transformerToken = (options.target === `dto`)
            ? TransformerHelper.getTransformerName(options.source as new (...args: any[]) => T, DtoDirection.TO_DTO)
            : TransformerHelper.getTransformerName(options.target as new (...args: any[]) => T, DtoDirection.FROM_DTO);

        container.register(transformerToken, constructor);
    }
}